import { render, staticRenderFns } from "./EmpleadoSueldos.vue?vue&type=template&id=4c9c659b&"
import script from "./EmpleadoSueldos.vue?vue&type=script&lang=js&"
export * from "./EmpleadoSueldos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports